import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { httpClient } from "../../../settings/apolloClient";
import SENSORS_QUERY from "../graphql/queries/sensorsQuery";
import { Sensors } from "./Sensors";

// Owns SENSORS_QUERY so that a sensor measurement — written into the cache by the
// session-lived SensorMeasurementSubscribersHost (in the Admin layout) roughly
// once a second per sensor — only re-renders this panel, and not the whole
// InstrumentsPanel tree (plant diagram, cards, image). Keeping the volatile
// `lastMeasurement` read here is what stops the per-measurement full-tree
// reconciliation that made the panel sluggish. cache-and-network also paints the
// last known values instantly on remount instead of blanking until the network
// answers. The subscriptions themselves are NOT here: mounting them inside this
// section tore them down on every tab switch and left the values frozen (the
// @absinthe/socket resubscribe race).
const SensorsSection = () => {
  const { data } = useQuery(SENSORS_QUERY, {
    fetchPolicy: "cache-and-network",
    client: httpClient,
  });

  const { sensors } = data || {};

  if (!sensors || !sensors.length) return null;

  return <Sensors sensorsList={sensors} />;
};

export default SensorsSection;
